export const FULLSCREEN_MAX_TEXT_LENGTH = 350;
